import BaseApi, { FetchMethodType } from 'api/BaseApi';

export interface IGetCurrentAccountResponse {
  email: string;
  phone: string;
  isEmailVerified: boolean;
  isMfaComplete: boolean;
  isPhoneVerified: boolean;
  borrowerId: string;
  currentApplicationId: string;
  firstName: string;
  lastName: string;
}

export enum VerificationCodeStatus {
  Pending = 'pending',
  Approved = 'approved',
  Canceled = 'canceled',
}

export interface IVerifyCodeResponse {
  status: VerificationCodeStatus;
  sendingAttemptsLeft: number;
}

interface IVerificationProcessApi {
  getCurrentAccount(): Promise<IGetCurrentAccountResponse>;
  sendEmailVerificationCode(applicationId: string): Promise<IVerifyCodeResponse>;
  verifyEmailVerificationCode(applicationId: string, code: string): Promise<IVerifyCodeResponse>;
  sendPhoneVerificationCode(applicationId: string, phone: string): Promise<IVerifyCodeResponse>;
  verifyPhoneVerificationCode(applicationId: string, code: string): Promise<IVerifyCodeResponse>;
}

export default class VerificationProcessApi extends BaseApi implements IVerificationProcessApi {
  public getCurrentAccount(): Promise<IGetCurrentAccountResponse> {
    return this.fetch('/verification-process/account');
  }

  public sendEmailVerificationCode(applicationId: string): Promise<IVerifyCodeResponse> {
    return this.fetch<IVerifyCodeResponse>('/verification-process/send-email-verification-code', {
      method: FetchMethodType.POST,
      body: {
        applicationId,
      },
    });
  }

  public verifyEmailVerificationCode(
    applicationId: string,
    code: string,
  ): Promise<IVerifyCodeResponse> {
    return this.fetch<IVerifyCodeResponse>('/verification-process/verify-email-verification-code', {
      method: FetchMethodType.POST,
      body: {
        applicationId,
        code,
      },
    });
  }

  public sendPhoneVerificationCode(
    applicationId: string,
    phone: string,
  ): Promise<IVerifyCodeResponse> {
    return this.fetch<IVerifyCodeResponse>('/verification-process/send-phone-verification-code', {
      method: FetchMethodType.POST,
      body: {
        applicationId,
        phone,
      },
    });
  }

  public verifyPhoneVerificationCode(
    applicationId: string,
    code: string,
  ): Promise<IVerifyCodeResponse> {
    return this.fetch<IVerifyCodeResponse>('/verification-process/verify-phone-verification-code', {
      method: FetchMethodType.POST,
      body: {
        applicationId,
        code,
      },
    });
  }
}
